import React from "react";
import { Calendar, Truck, Package } from "lucide-react";
import { motion } from "framer-motion";

const Activities: React.FC<{ content?: any }> = ({ content }) => {
  const activitiesList = content?.items || [
    {
      title: "First Rig Move Oxy Contract",
      description: "Transport Division completed its first rig move to Oxy contract early this morning. R952 was moved successfully, under a heavy audience of Oxy and Ensign.",
      images: ["/MUK-001-2015-214.jpg", "/MUK-001-2015-222.jpg"],
      iconName: "Truck",
    },
    {
      title: "Oil-Field Rig & Hoist Moves",
      description: "Oil-field activities are core to the heart of the Omani economy, and Hamdan Transport has been providing International Standard rig movement services to major Partners, operating in the PDO region.",
      images: [],
      iconName: "Package",
    },
    {
      title: "Camps & Installation Repositioning",
      description: "Hamdan Transport provides comprehensive transport packages for industrial, or construction camp settlement, whether new or repositioned.",
      images: [],
      iconName: "Calendar",
    },
    {
      title: "Casing & Tubing Haulage",
      description: "With rapid industrialization, the need for casing and tubing work has increased manifold, and transporting them is a tricky affair. Hamdan Transport has been professionally, and successfully, carrying out the same for a long time.",
      images: [],
      iconName: "Calendar",
    },
    {
      title: "Integrated & General Cargo Haulage",
      description: "With over 200 fleets for general cargo services, undoubtedly Hamdan Transport is the major player in this field, and add to that integrated facilities like warehousing, and safe docking makes it the unparalleled leader.",
      images: [],
      iconName: "Calendar",
    },
  ];

  const iconMap: Record<string, any> = { Truck, Package, Calendar };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 tracking-tight">
            {content?.title || "History"}
          </h2>
          <p className="text-gray-500 max-w-4xl mx-auto text-[15px] md:text-base leading-relaxed text-center font-normal">
            {content?.desc || "A proud legacy of over 50 years, tracing HTD’s growth from a regional transport company to a nationwide logistics leader."}
          </p>
        </div>

        {/* Structured Grid Layout to match Image 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {/* First Item (Special Layout with Top and Bottom Image) */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full">
            {activitiesList[0]?.images?.[0] && (
              <img
                src={activitiesList[0].images[0]}
                alt={activitiesList[0].title}
                className="w-full h-48 object-cover"
              />
            )}
            <div className="p-6 pb-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-red-500 rounded-full text-white">
                  {React.createElement(iconMap[activitiesList[0]?.iconName] || Truck, { className: "w-4 h-4" })}
                </div>
                <h3 className="text-base font-bold text-gray-900 leading-tight">
                  {activitiesList[0]?.title}
                </h3>
              </div>
              <p className="text-[13px] text-gray-600 leading-relaxed text-left">
                {activitiesList[0]?.description}
              </p>
            </div>
            {activitiesList[0]?.images?.[1] && (
              <div className="px-6 pb-6 mt-auto">
                <img
                  src={activitiesList[0].images[1]}
                  alt={`${activitiesList[0].title} bottom`}
                  className="w-full h-24 object-cover rounded-lg shadow-sm"
                />
              </div>
            )}
          </div>

          {/* Second Column (Items 2 and 3) */}
          <div className="space-y-6">
            {activitiesList.slice(1, 3).map((activity: any, idx: number) => {
              const Icon = iconMap[activity.iconName] || Calendar;
              return (
                <div key={idx} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-red-500 rounded-full text-white flex-shrink-0">
                      <Icon className="w-4 h-4" />
                    </div>
                    <h3 className="text-base font-bold text-gray-900 leading-tight">
                      {activity.title}
                    </h3>
                  </div>
                  <p className="text-[13px] text-gray-600 leading-relaxed text-left">
                    {activity.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Third Column (Items 4 and 5) */}
          <div className="space-y-6">
            {activitiesList.slice(3, 5).map((activity: any, idx: number) => {
              const Icon = iconMap[activity.iconName] || Calendar;
              return (
                <div key={idx} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 ">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-red-500 rounded-full text-white flex-shrink-0">
                      <Icon className="w-4 h-4" />
                    </div>
                    <h3 className="text-base font-bold text-gray-900 leading-tight">
                      {activity.title}
                    </h3>
                  </div>
                  <p className="text-[13px] text-gray-600 leading-relaxed text-left">
                    {activity.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Activities;
